"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prereleaseFlags = exports.isDebug = exports.numberformat = undefined;

var _paths = require("../../../firebase-connect/paths");

var paths = _interopRequireWildcard(_paths);

var _queryStatus = require("../../../firebase-connect/query-status");

var _reselect = require("reselect");

var _auth = require("../auth");

var Auth = _interopRequireWildcard(_auth);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var path = (0, _reselect.createSelector)(_lodash2.default.flow(Auth.userId, Auth.Id.unwrap), paths.options.data);

var rawState = (0, _queryStatus.selectPath)(path);
var localState = (0, _reselect.createSelector)(rawState, function (state) {
  return state || {};
});

var numberformat = exports.numberformat = (0, _reselect.createSelector)(localState, function (state) {
  return state.numberformat || "standard";
});
var isDebug = exports.isDebug = (0, _reselect.createSelector)(localState, function (state) {
  return state.isDebug || false;
});
var prereleaseFlags = exports.prereleaseFlags = (0, _reselect.createSelector)(localState, function (state) {
  return state.prereleaseFlags != null ? state.prereleaseFlags : true;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/options/root.js
// module id = 787
// module chunks = 0